import { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

/**
 * Password field with a conventional Show/Hide toggle. Renders the existing `input-field` styling
 * and only flips this field between password/text — value, validation, autocomplete and submit are
 * untouched. Forwards every prop (value, onChange, required, minLength, autoComplete, data-testid…)
 * straight to the underlying <input>.
 */
export function PasswordInput({ className = "input-field", ...rest }) {
  const [show, setShow] = useState(false);
  const testId = rest["data-testid"];
  return (
    <div className="relative">
      <input {...rest} type={show ? "text" : "password"} className={`${className} pr-10`} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        title={show ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-[hsl(var(--muted))] hover:text-[hsl(var(--foreground))] focus:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--foreground))] rounded-r-[2px]"
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
      >
        {show ? <EyeSlash size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
